// src/firebase.js
import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
// Add more imports as needed, e.g. getAuth, getFirestore

const firebaseConfig = {
  apiKey: "AIzaSyAMv48C8waePJ1mEXOLh8Cw8ec7kqQKmQE",
  authDomain: "tunecraft-8e11b.firebaseapp.com",
  projectId: "tunecraft-8e11b",
  storageBucket: "tunecraft-8e11b.firebasestorage.app",
  messagingSenderId: "247408646861",
  appId: "1:247408646861:web:61737f59b78b2b5110a784",
  measurementId: "G-60KR184TSS"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics only in browser environment
let analytics = null;
if (typeof window !== 'undefined') {
  try {
    analytics = getAnalytics(app);
  } catch (error) {
    console.warn('Firebase Analytics initialization failed:', error);
  }
}

export { analytics, app };

